import React, { Component } from "react";
import { observer } from "mobx-react";
import {
    fn_change_init_view,
} from "../../../../function/FnBodySetting";
import { fn_orderEndDetail, fn_orderEndDetailView } from "function/FnBodyDetail"
import { fn_return_success } from "http/SettingConn"
import partialCancel from "static-file/images/partialCancel.png";
import partialCancelNew from "static-file/images/partialCancelNew.png";

@observer
class PartialCancelView extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { rootStore } = this.props;
        const layerStore = rootStore.layerStore;

        return (
            <div className={"layer_comm layer_common_type " + ((layerStore.getLayerPartialCancelView) ? ' layer_open' : '')}>
                <div className="bg"></div>
                <div className="layer_content">
                    <div className="article_common_type">
                        <div className="section">
                            <div className="info">
                                <div className="top">
                                    <span className="top_txt">부분취소 매출 처리 안내</span>
                                </div>
                                <div className="content cancel">
                                    {
                                        (rootStore.layerStore.getLayerPartialCancelType.type == "first") ? <img src={partialCancelNew} width="852" height="469" alt={"info"} /> : <img src={partialCancel} width="852" height="469" alt={"info"} />
                                    }
                                    <button className="detail" onClick={event => { event.preventDefault(); 
                                        layerStore.setLayerPartialCancelView(false); 
                                        //fn_return_success(rootStore, rootStore.settingStore.getReturnFailOn.pendingNo)
                                        fn_orderEndDetailView(rootStore, rootStore.layerStore.getLayerPartialCancelType.mobileOrderNo)
                                    }}>주문 상세로 이동</button>
                                </div>
                            </div>
                        </div>

                        <div className="btn_close">
                            <button
                                onClick={event => { event.preventDefault(); layerStore.setLayerPartialCancelView(false); fn_change_init_view(rootStore); }}
                            ><span>닫기</span></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PartialCancelView;